export default "__VITE_ASSET__BCFRXvro__"